export default "__VITE_ASSET__BaiVqsMM__"